import type AppState from 'src/types/appState';

export const globalSelector = (state: AppState) => ({
  page: state.tealium.page,
  isDataCleanUpComplete: state.app.isDataCleanupComplete,
  hasHirerInfo: Boolean(
    state.tealium.hirerInfo.firstName &&
      state.tealium.hirerInfo.lastName &&
      state.tealium.hirerInfo.emailAddress &&
      state.tealium.hirerAdPurchaser,
  ),
});
